export default __webpack_public_path__ + "static/media/img-signin.bb4ff7b3.svg";